// eslint-disable-next-line import/prefer-default-export
export const listSelections = /* GraphQL */ `
    query ListSelections(
        $id: ID
        $filter: ModelSelectionFilterInput
        $limit: Int
        $nextToken: String
        $sortDirection: ModelSortDirection
    ) {
        listSelections(
            id: $id
            filter: $filter
            limit: $limit
            nextToken: $nextToken
            sortDirection: $sortDirection
        ) {
            items {
                id
                part
                ensemble {
                    id
                    name
                    code
                }
                application {
                    id
                    instrument {
                        id
                        name
                    }
                    teacher {
                        id
                        name {
                            first
                            last
                        }
                    }
                    student {
                        id
                        name {
                            first
                            last
                            preferred
                        }
                        address {
                            line1
                            line2
                            city
                            state
                            zip
                        }
                        school {
                            id
                            name {
                                legal
                                popular
                            }
                        }
                    }
                }
            }
            nextToken
        }
    }
`;

export const getUser = /* GraphQL */ `
    query GetUser($id: ID!) {
        getUser(id: $id) {
            id
            name {
                first
                last
            }
            address {
                line1
                line2
                city
                county
                state
                zip
            }
            ensembleIds
        }
    }
`;
